export default {
  allOurProductsNew: {
    id: 'header_all_our_products',
    defaultMessage: 'All our products',
  },
  aboutUs: {
    id: 'header_to_about_us',
    defaultMessage: 'About us',
  },
  sellProduct: {
    id: 'header_to_buyback',
    defaultMessage: 'Sell a product',
  },
  help: {
    id: 'header_to_help',
    defaultMessage: 'Help',
  },
  snowAltEnable: {
    id: 'snow_alt_enable',
    defaultMessage: 'Make it snow!',
  },
  snowAltDisable: {
    id: 'snow_alt_disable',
    defaultMessage: 'stop the snow',
  },
}
